export default __webpack_public_path__ + "static/media/603ff2c336038a3563dde353_image-3-teams-technology-template.7f710851.svg";